export interface RtpPacket {
    payloadType: number;
    marker: boolean;
    sequenceNumber: number;
    timestamp: number;
    ssrc: number;
    payload: Uint8Array;
}

const FIXED_HEADER_BYTES = 12;

/** Parses an RTP packet (RFC 3550 §5.1). Returns null for anything that is not valid RTP v2. */
export function parseRtpPacket(bytes: Uint8Array) : RtpPacket | null {
    if (bytes.length < FIXED_HEADER_BYTES) {
        return null;
    }

    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const first = view.getUint8(0);
    if (first >> 6 !== 2) {
        return null;
    }

    const second = view.getUint8(1);

    let start = FIXED_HEADER_BYTES + (first & 0x0f) * 4; // CSRC list
    if (first & 0x10) {
        // Header extension: 16-bit profile, 16-bit length in 32-bit words.
        if (start + 4 > bytes.length) {
            return null;
        }

        start += 4 + view.getUint16(start + 2) * 4;
    }
    let end = bytes.length;
    if (first & 0x20) {
        // Padding: the last byte counts the padding bytes, itself included.
        const padding = view.getUint8(end - 1);
        if (padding === 0) {
            return null;
        }

        end -= padding;
    }
    if (start > end) {
        return null;
    }

    return {
        payloadType: second & 0x7f,
        marker: (second & 0x80) !== 0,
        sequenceNumber: view.getUint16(2),
        timestamp: view.getUint32(4),
        ssrc: view.getUint32(8),
        payload: bytes.subarray(start, end),
    };
}
